import { Card, CardBody, Table, TabPane } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import CreateDepartmentModal from "../Modals/CreateDepartment";
import IconButton from "../../../../../components/Buttons/IconButton";
import { IoCreateOutline } from "react-icons/io5";
import { BsTrash3 } from "react-icons/bs";
import ConfirmationModal from "../../../../../components/Modals/Confirmation";
import { del } from "../../../../../utils/helpers/api";
import { toast } from "react-toastify";

function DepartmentsTab({ departments, refreshSettings }) {
  const { t } = useTranslation();
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [departmentToDelete, setDepartmentToDelete] = useState(null);
  const [departmentToEdit, setDepartmentToEdit] = useState(null);

  const deleteDepartment = async () => {
    const data = await del(`/hr/departments/delete/${departmentToDelete}`);
    if(data?.success) {
      refreshSettings();
      setDepartmentToDelete(null);
      toast.success(t('hr.settings.departments.deleted'));
    }
  }

  return(
    <TabPane tabId="departments">
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="text-muted small fw-semibold text-uppercase mb-0">
              Departments
            </p>
            <DefaultButton
              color="primary"
              size="sm"
              onClick={() => {
                setDepartmentToEdit(null);
                setCreateModalOpen(true);
              }}
            >
              + { t('common.create') }
            </DefaultButton>
          </div>

          <Table hover responsive className="mb-0">
            <thead className="table-light">
              <tr>
                <th>{ t('common.name') }</th>
                <th>{ t('timeline.createdBy') }</th>
                <th>{ t('common.actions') }</th>
              </tr>
            </thead>
            <tbody>
              {departments?.map(department => (
                <tr key={department?.id}>
                  <td>{ department?.name }</td>
                  <td>{ department?.created_by?.name }</td>
                  <td>
                    <div className="d-flex align-items-center gap-2 h-100">
                      <IconButton
                        size="sm" 
                        outline 
                        color="secondary"
                        onClick={() => {
                          setDepartmentToEdit(department);
                          setCreateModalOpen(true);
                        }}
                      >
                        <IoCreateOutline />
                      </IconButton>
                      <IconButton
                        size="sm" 
                        outline 
                        color="danger"
                        onClick={() => setDepartmentToDelete(department.id)}
                      >
                        <BsTrash3 />
                      </IconButton>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <CreateDepartmentModal 
        isOpen={createModalOpen}
        toggle={() => setCreateModalOpen(!createModalOpen)}
        departmentToEdit={departmentToEdit}
        refreshSettings={refreshSettings}
      />

      <ConfirmationModal
        isOpen={departmentToDelete !== null}
        title={t('hr.settings.departments.deleteTitle')}
        message={t('hr.settings.departments.deleteMessage')}
        onConfirm={deleteDepartment}
        toggle={() => setDepartmentToDelete(null)}
      />
    </TabPane>
  );
}

export default DepartmentsTab;